import { HYDRATE } from "next-redux-wrapper";
import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../interfaces/user.interface";
import { AppState } from "./store";
const hydrate = createAction<AppState>(HYDRATE);
export const API = process.env.NEXT_PUBLIC_API_URL;
import { clearAuthData } from "@shared/lib/utils";
import { loginUser } from "./thunks/loginUser";
import { registerUser } from "./thunks/registerUser";
import { AuthState } from "./types";

const initialState: AuthState = {
    currentUser: null,
    authState: false,
    isLoggingIn: false,
    isRegistering: false,
    errorMessage: null,
    isPersonal: null
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAuthState(state, action) {
            state.authState = action.payload;
        },
        logoutUser(state) {
            state.authState = false;
            state.currentUser = null;
            state.accessToken = undefined;
            clearAuthData();
        },
        setUser(state, action: PayloadAction<User>) {
            state.currentUser = action.payload;
        },
        setRouteToOpen(state, action: PayloadAction<string>) {
            state.routeToOpen = action.payload;
        },
        clearErrors(state) {
            state.errorMessage = null;
        },
        setReduxAccessToken(state, action: PayloadAction<string>) {
            state.accessToken = action.payload;
        },
        setEmailMemory(state, action: PayloadAction<string>) {
            state.emailMemory = action.payload;
        },
        setPhoneMemory(state, action: PayloadAction<string>) {
            debugger;
            state.phoneMemory = action.payload;
        },
        setIsPersonal(state, action: PayloadAction<boolean | null>) {
            state.isPersonal = action.payload;
        }
    },

    extraReducers: (builder) => {
        builder.addCase(hydrate, (state, action) => {
            if (action.payload.auth) {
                state.currentUser = action.payload.auth.currentUser ?? state.currentUser;
                state.authState = action.payload.auth.authState ?? state.authState;
            }
        });

        builder.addCase(loginUser.fulfilled, (state, action) => {
            state.isLoggingIn = false;
            state.authState = true;
            state.currentUser = action.payload?.user || null;
        });

        builder.addCase(loginUser.pending, (state) => {
            state.errorMessage = null;
            state.isLoggingIn = true;
        });

        builder.addCase(loginUser.rejected, (state, action) => {
            if (action.payload) {
                state.errorMessage = action.payload.message;
            }
            state.isLoggingIn = false;
        });

        builder.addCase(registerUser.fulfilled, (state, action) => {
            state.isRegistering = false;
            state.authState = true;
            state.currentUser = action.payload?.user || null;
        });

        builder.addCase(registerUser.pending, (state) => {
            state.errorMessage = null;
            state.isRegistering = true;
        });

        builder.addCase(registerUser.rejected, (state, action) => {
            if (action.payload) {
                state.errorMessage = action.payload.message;
            }
            state.isRegistering = false;
        });
    }
});

export const {
    setAuthState,
    logoutUser,
    setUser,
    setRouteToOpen,
    clearErrors,
    setReduxAccessToken,
    setEmailMemory,
    setPhoneMemory,
    setIsPersonal
} = authSlice.actions;

export const selectIsCompany = (state: AppState) => Boolean(state.auth.currentUser?.isCompany);
export const selectIsAuthenticated = (state: AppState) => Boolean(state.auth.currentUser);
export const currentUserState = (state: AppState) => state.auth.currentUser;

export default authSlice.reducer;
export * from "./thunks";
export * from "@shared/lib/utils/auth";